<span class="benefit">
  <i class="fa-icon d-inline-block me-2" [innerHTML]="svg | bypassSecurityTrust : 'html'"></i>
  @if (language != 'en') {
    <span [innerHtml]="name"></span>
  }
  @if (language == 'en') {
    <span [innerHtml]="name_en"></span>
  }
</span>
